import { toast } from 'react-toastify';

const success = (str: string, opt = {}) => {
  toast.success(str, opt);
};

const error = (str: string, opt = {}) => {
  toast.error(str, opt);
};

const info = (str: string, opt = {}) => {
  toast.info(str, opt);
};

const remove = () => {
  toast.dismiss();
};

const snackbar = { success, error, info, remove };

export default snackbar;
